import AccordionItens from "./AccordionItens";
import React from "react";
import SideBanner from "components/layout/SideBanner";

import { Body, Container, Content } from "./styles";

const TrocaTitularidade = (): JSX.Element => {
  const step = {
    h1: "Troca de titularidade",
    h2: "Olá! Boas-vindas à você que chegou para somar energias. Confira abaixo como funciona a troca de titularidade da sua conta de gás de apartamento ou loja com medição individualizada:",
  };

  return (
    <Container>
      <SideBanner
        activated={1}
        header={step}
        steppers={["Troca de titularidade"]}
      />
      <Content>
        <Body>
          <AccordionItens step={step} />
        </Body>
      </Content>
    </Container>
  );
};

export default TrocaTitularidade;
